/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type PendingTradesTable_viewer$ref = any;
export type PendingTradesTableQueryVariables = {
    readonly count: number;
    readonly cursor?: string | null;
    readonly supplierIds?: ReadonlyArray<string> | null;
    readonly traderIds?: ReadonlyArray<string> | null;
    readonly startDate?: any | null;
    readonly endDate?: any | null;
};
export type PendingTradesTableQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": PendingTradesTable_viewer$ref;
    };
};
export type PendingTradesTableQuery = {
    readonly response: PendingTradesTableQueryResponse;
    readonly variables: PendingTradesTableQueryVariables;
};



/*
query PendingTradesTableQuery(
  $count: Int!
  $cursor: String
  $supplierIds: [ID!]
  $traderIds: [ID!]
  $startDate: DateTime
  $endDate: DateTime
) {
  viewer {
    ...PendingTradesTable_viewer_1qdc0
  }
}

fragment PendingTradesTable_viewer_1qdc0 on Viewer {
  trades(first: $count, after: $cursor, status: pending, supplierIds: $supplierIds, traderIds: $traderIds, from: $startDate, to: $endDate) {
    total
    edges {
      node {
        id
        ...PendingTradeRow_trade
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment PendingTradeRow_trade on Trade {
  id
  refNumber
  tradeTimestamp
  company {
    id
    runningBalance
    tradeLimit {
      limit
    }
    info {
      name
    }
  }
  createdBy {
    id
    displayName
  }
  status
  weight
  usdPerTroyOunce
  zarToUsd
  zarPerGram
  requestedZarPerGram
  notes
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "supplierIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "traderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startDate",
    "type": "DateTime",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endDate",
    "type": "DateTime",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "startDate",
    "type": "DateTime"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": "pending",
    "type": "TradeStatus"
  },
  {
    "kind": "Variable",
    "name": "supplierIds",
    "variableName": "supplierIds",
    "type": "[ID!]"
  },
  {
    "kind": "Variable",
    "name": "to",
    "variableName": "endDate",
    "type": "DateTime"
  },
  {
    "kind": "Variable",
    "name": "traderIds",
    "variableName": "traderIds",
    "type": "[ID!]"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "PendingTradesTableQuery",
  "id": null,
  "text": "query PendingTradesTableQuery(\n  $count: Int!\n  $cursor: String\n  $supplierIds: [ID!]\n  $traderIds: [ID!]\n  $startDate: DateTime\n  $endDate: DateTime\n) {\n  viewer {\n    ...PendingTradesTable_viewer_1qdc0\n  }\n}\n\nfragment PendingTradesTable_viewer_1qdc0 on Viewer {\n  trades(first: $count, after: $cursor, status: pending, supplierIds: $supplierIds, traderIds: $traderIds, from: $startDate, to: $endDate) {\n    total\n    edges {\n      node {\n        id\n        ...PendingTradeRow_trade\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PendingTradeRow_trade on Trade {\n  id\n  refNumber\n  tradeTimestamp\n  company {\n    id\n    runningBalance\n    tradeLimit {\n      limit\n    }\n    info {\n      name\n    }\n  }\n  createdBy {\n    id\n    displayName\n  }\n  status\n  weight\n  usdPerTroyOunce\n  zarToUsd\n  zarPerGram\n  requestedZarPerGram\n  notes\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PendingTradesTableQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "viewer",
        "name": "__viewer_viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PendingTradesTable_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "endDate",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "startDate",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "supplierIds",
                "variableName": "supplierIds",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "traderIds",
                "variableName": "traderIds",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PendingTradesTableQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "trades",
            "storageKey": null,
            "args": v1,
            "concreteType": "ViewerTradesConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ViewerTradesEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Trade",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "refNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "tradeTimestamp",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "company",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Company",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "runningBalance",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tradeLimit",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CompanyTradeLimit",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "limit",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "info",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CompanyInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "name",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "createdBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AuditUser",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayName",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "weight",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "usdPerTroyOunce",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "zarToUsd",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "zarPerGram",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "requestedZarPerGram",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "notes",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "trades",
            "args": v1,
            "handle": "connection",
            "key": "ViewerPending_trades",
            "filters": [
              "supplierIds"
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "viewer",
        "args": null,
        "handle": "viewer",
        "key": "",
        "filters": null
      }
    ]
  }
};
})();
(node as any).hash = 'efe22495a2a0d8d4ad08d1048870e2b4';
export default node;
